import React, { Component } from "react";
import Table from "../common/table/table";
import Team from "../team";

class RankingTable extends Component {
  state = { matchId: -1 };

  columns = [
    {
      key: "user",
      label: "User",
      className: "col-6",
      content: ranking => <span>{ranking.user.name}</span>
    },
    {
      key: "bet",
      label: "Bet",
      className: "col-4",
      content: ranking => (
        <span>{ranking.scoreHome + " - " + ranking.scoreAway}</span>
      )
    },
    {
      key: "scoreUser",
      label: "Score",
      className: "col-2 right",
      content: ranking => <span>{ranking.scoreUser}</span>
    }
    //,
    // {
    //   key: "points",
    //   label: "Points",
    //   className: "col-2 right",
    //   content: ranking => <span>{ranking.points}</span>
    // }
  ];

  getPreviousMatch(ranking) {
    if (!ranking || ranking.length === 0) return;

    let { matchId } = this.state;
    if (matchId === -1) matchId = ranking[0].match.id;

    let exists = false;
    for (let i in ranking) {
      exists = exists || ranking[i].match.id === matchId;
      if (exists && ranking[i].match.id !== matchId) {
        this.setState({ matchId: ranking[i].match.id });
        return;
      }
    }
  }

  getNextMatch(ranking) {
    if (!ranking || ranking.length === 0) return;

    let { matchId } = this.state;
    if (matchId === -1) matchId = ranking[0].match.id;

    let exists = false;
    const length = ranking.length - 1;
    for (let i in ranking) {
      exists = exists || ranking[length - i].match.id === matchId;
      if (exists && ranking[length - i].match.id !== matchId) {
        this.setState({ matchId: ranking[length - i].match.id });
        return;
      }
    }
  }

  render() {
    const { ranking } = this.props;
    const { matchId } = this.state;

    if (ranking.length > 0) {
      const match =
        matchId === -1
          ? ranking[0].match
          : ranking.filter(r => r.match.id === matchId)[0].match;

      if (match) {
        return (
          <div className="container">
            <table className="center">
              <tbody>
                <tr>
                  <td colSpan="4" className="league">
                    {match.league.name + " " + match.season.name}
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" className="match-day">
                    {match.matchDay.name}
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" className="date">
                    {match.dateTime
                      .replace("T", " - ")
                      .substring(0, match.dateTime.length - 1)}
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      onClick={() => this.getNextMatch(ranking)}
                      className="cursor"
                    >
                      <i className="fa fa-caret-left fa-2x" />
                    </a>
                  </td>
                  <td className="match-teams">
                    <Team
                      name={match.teamHome.name}
                      logo={match.teamHome.logo}
                    />
                    <span className="score">
                      {match.isFinished ? match.scoreHome : "-"}
                    </span>
                  </td>
                  <td className="match-teams">
                    <Team
                      name={match.teamAway.name}
                      logo={match.teamAway.logo}
                    />
                    <span className="score">
                      {match.isFinished ? match.scoreAway : "-"}
                    </span>
                  </td>
                  <td>
                    <a
                      onClick={() => this.getPreviousMatch(ranking)}
                      className="cursor"
                    >
                      <i className="fa fa-caret-right fa-2x" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <Table
              columns={this.columns}
              data={ranking.filter(r => r.match.id === match.id)}
            />
          </div>
        );
      }
    }
    return null;
  }
}

export default RankingTable;



// WEBPACK FOOTER //
// ./src/components/ranking/rankingTable.jsx